import { createFileRoute } from '@tanstack/react-router';

import { SetupDataPage } from '~/features/setup-data/setup-data-page';

/** Bring in your data, on OS's page: the setup files' rows after Build (step 3.2 of docs/plans/setup-file-data.md). */
export const Route = createFileRoute('/_app/coach/imports/setup')({ component: SetupDataPage });
